import React from 'react';

/** Visible immediately — animation is optional and must never hide copy. */
export function Reveal({ children, className = '' }) {
  return <div className={className}>{children}</div>;
}

export function SplitText({ text, className = '' }) {
  return <span className={className}>{text}</span>;
}

export function CharReveal({ text, className = '' }) {
  return <span className={className}>{text}</span>;
}
